module.exports = __webpack_public_path__ + "static/img/frack.dafcf1c2.png";